import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GoToSelect } from 'datastake-daf/dist/components';
import Style from '../style';
import SubjectDetails from '../../sca-dds-kyc-widgets/subject-details';
import SupplyChainDetails from '../../sca-dds-kyc-widgets/supply-chain-details';
import DueDilligenceOverview from '../../sca-dds-kyc-widgets/due-dilligence-overview';

export default function DDSLayout({
  data = null,
  other = {},
  redirectToView = () => { },
  getOption = () => { },
}) {
  const { user } = useSelector((state) => state.authentication);

  const {
    subjectName,
    country,
    legalForm,
    type,
  } = useMemo(() => {
    let subjectName, legalForm, type, country;
    if (user) {
      subjectName = user?.organisationName;
      country = user.country;
      if (user.company) {
        type = user.company.category;
        legalForm = user.company.subCategory;
      }
    }
    return {
      subjectName, legalForm, type, country,
    };
  }, [user]);

  if (data) {
    return (
      <div>
        <Style>
          <div className="go-select-cont">
            <GoToSelect
              className="full mb-0"
              onChange={() => { }}
              options={[]}
              setValue={() => { }}
              value={undefined}
            >
            </GoToSelect>
          </div>
          <div className="sections-cont">
            <section>
              <SubjectDetails
                isOwnData
                sources={1}
                data={{
                  ...data.subjectDetails,
                  subjectName,
                  country,
                  legalForm,
                  type,
                }}
                namespace="dd"
                getOption={getOption}
              />
              <SupplyChainDetails
                data={data.supplyChainDetails}
                namespace="dd"
                getOption={getOption}
              />
            </section>
            <DueDilligenceOverview
              data={{ data: data.ddsData, sections: data.ddsSections }}
              other={other}
              namespace="dd"
              redirectToView={redirectToView}
              hasDDSystems={true}
            />
          </div>
        </Style>
      </div>
    );
  }

  return null;
}
